import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-9874aab2"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "toggle-button" }
const _hoisted_2 = ["checked"]
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "toggle-track" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "toggle-circle" })
], -1))


export default /*#__PURE__*/_defineComponent({
  __name: 'ToggleButton',
  props: {
  checked: {
    type: Boolean,
    default: false
  }
},
  emits: ["click"],
  setup(__props, { emit: emits }) {





const onClick = () => {
  emits("click");
};

// トグルボタンの円のスタイル
const circle = {
  color: "#FFFFFF",
  diameter: "20px",
  borderRadius: "100%",
  distance: "15px" // トグルボタンON/OFF時の円の中心移動距離
};

// トグルボタン外周の楕円形部分のスタイル
const track = {
  color: "#D9D9D9",
  activeColor: "#3F88AE",
  width: "40px",
  height: "24px",
  borderWidth: "0px",
  borderRadius: "70px"
};

const toggleStyle = {
  "--circle-color": circle.color,
  "--circle-diameter": circle.diameter,
  "--circle-border-radius": circle.borderRadius,
  "--circle-distance": circle.distance,
  "--track-color": track.color,
  "--track-active-color": track.activeColor,
  "--track-width": track.width,
  "--track-height": track.height,
  "--track-border-width": track.borderWidth,
  "--track-border-radius": track.borderRadius
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "toggle-wrapper",
    style: toggleStyle
  }, [
    _createElementVNode("label", _hoisted_1, [
      _createElementVNode("input", {
        checked: __props.checked,
        type: "checkbox",
        onClick: onClick
      }, null, 8, _hoisted_2),
      _createTextVNode(),
      _hoisted_3
    ])
  ]))
}
}

})